<template>
    <div>
      <van-nav-bar
        title="任务详情"
        left-text="返回"
        right-text="保存"
        left-arrow
        @click-left="onClickLeft"
        @click-right="onClickRight"
        fixed
      />
      <!--任务详情-->
      <div style="margin-top: 45px;">
        <h2 class="van-doc-demo-block__title">任务标题</h2>
        <van-cell-group>
          <van-cell :title="info.title"/>
        </van-cell-group>

        <h2 class="van-doc-demo-block__title">任务明细</h2>
        <van-cell-group>
          <van-cell :title="info.start_content"/>
        </van-cell-group>

        <h2 class="van-doc-demo-block__title">开始时间</h2>
        <van-cell-group>
          <van-cell :title="info.start_time"/>
        </van-cell-group>

        <h2 class="van-doc-demo-block__title">截止时间</h2>
        <van-cell-group>
          <van-cell :title="info.end_time"/>
        </van-cell-group>

        <h2 class="van-doc-demo-block__title">完成情况</h2>
        <van-cell-group>
          <van-field style="background-color: #d2d6de" v-model="info.end_content" type="textarea" placeholder="请输入任务的完成情况" rows="3" autosize/>
        </van-cell-group>
      </div>
      <!--任务详情-->
    </div>
</template>

<script>
    import {formatDate} from '../../common/date.js';
    export default {
      data() {
        return {
          info : [],
        };
      },
      methods: {
        onClickLeft() {
          this.$router.back(-1);
        },
        onClickRight() {
          this.$api.post('/api/employee/task/finish',{
              id:this.info.id,
              end_content:this.info.end_content,
            }, r => {
              this.$router.push('/task');
            }
          )
        },
      },
      created: function () {
        window.scroll(0, 0)
        //获取任务信息
        this.id = this.$route.params.id
        this.$api.post('/api/employee/task/detail', {
          id: this.id,
        },task => {
          this.info = task
        })
      }
    }
</script>

<style scoped>
  .van-field .van-cell__title {
    min-width: 80px;
  }
  .van-panel__log {
    font-size: 14px;
    position: absolute;
    top: 10px;
    right: 15px;
    color: #26a2ff;
  }
  .van-doc-demo-block__title {
    margin: 0;
    font-weight: 800;
    font-size: 15px;
    color: rgba(69,90,100,.6);
    padding: 10px 10px 5px;
  }
  .pop_button{
    width: 80%;
    margin-left: 10%;
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .radio-tag{
    width: 38px;
    height: 18px;
    text-align: center;
    line-height: 18px;
    margin-bottom: 5px;
  }

</style>



// WEBPACK FOOTER //
// src/pages/task/edit.vue